/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




/**
 * @summary Retrieves a platform's Ageless marketing deployment checklist progress.
 */
export const getDeploymentChecklistProgress = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse>(
      {url: `/api/v1/ageless/${platformId}/marketing/deployment-checklist`, method: 'GET', signal
    },
      );
    }
  



export const getGetDeploymentChecklistProgressQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/${platformId}/marketing/deployment-checklist`
    ] as const;
    }

    
export const getGetDeploymentChecklistProgressQueryOptions = <TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeploymentChecklistProgressQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>> = ({ signal }) => getDeploymentChecklistProgress(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeploymentChecklistProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>>
export type GetDeploymentChecklistProgressQueryError = ErrorType<unknown>


/**
 * @summary Retrieves a platform's Ageless marketing deployment checklist progress.
 */

export function useGetDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeploymentChecklistProgressQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Marks an Ageless marketing deployment checklist item as completed for a platform.
 */
export const markChecklistItemAsCompleted = (
    platformId: string,
    itemSlug: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/${platformId}/marketing/deployment-checklist/items/${itemSlug}/complete`, method: 'POST', signal
    },
      );
    }
  


export const getMarkChecklistItemAsCompletedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, TError,{platformId: string;itemSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, TError,{platformId: string;itemSlug: string}, TContext> => {

const mutationKey = ['markChecklistItemAsCompleted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, {platformId: string;itemSlug: string}> = (props) => {
          const {platformId,itemSlug} = props ?? {};

          return  markChecklistItemAsCompleted(platformId,itemSlug,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type MarkChecklistItemAsCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>>
    
    export type MarkChecklistItemAsCompletedMutationError = ErrorType<unknown>

    /**
 * @summary Marks an Ageless marketing deployment checklist item as completed for a platform.
 */
export const useMarkChecklistItemAsCompleted = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, TError,{platformId: string;itemSlug: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof markChecklistItemAsCompleted>>,
        TError,
        {platformId: string;itemSlug: string},
        TContext
      > => {
      return useMutation(getMarkChecklistItemAsCompletedMutationOptions(options));
    }
    /**
 * @summary Marks an Ageless marketing deployment checklist item as incomplete for a platform.
 */
export const markChecklistItemAsIncomplete = (
    platformId: string,
    itemSlug: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/${platformId}/marketing/deployment-checklist/items/${itemSlug}/complete`, method: 'DELETE', signal
    },
      );
    }
  


export const getMarkChecklistItemAsIncompleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, TError,{platformId: string;itemSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, TError,{platformId: string;itemSlug: string}, TContext> => {

const mutationKey = ['markChecklistItemAsIncomplete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, {platformId: string;itemSlug: string}> = (props) => {
          const {platformId,itemSlug} = props ?? {};

          return  markChecklistItemAsIncomplete(platformId,itemSlug,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type MarkChecklistItemAsIncompleteMutationResult = NonNullable<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>>
    
    export type MarkChecklistItemAsIncompleteMutationError = ErrorType<unknown>

    /**
 * @summary Marks an Ageless marketing deployment checklist item as incomplete for a platform.
 */
export const useMarkChecklistItemAsIncomplete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, TError,{platformId: string;itemSlug: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>,
        TError,
        {platformId: string;itemSlug: string},
        TContext
      > => {
      return useMutation(getMarkChecklistItemAsIncompleteMutationOptions(options));
    }
    